export const sysAdmins = ['rodolfo.oliveira@jobc.com.br']
